import { CounterResetPeriod } from '@g2-shared/api-client/generated/settlement-app';

export const CounterResetPeriodLabelMapper: Record<CounterResetPeriod, string> = {
  [CounterResetPeriod.NONE]: 'None',
  [CounterResetPeriod.DAILY]: 'Daily',
  [CounterResetPeriod.WEEKLY]: 'Weekly',
  [CounterResetPeriod.MONTHLY]: 'Monthly',
  [CounterResetPeriod.QUARTERLY]: 'Quarterly',
  [CounterResetPeriod.SEMIYEARLY]: 'Semiyearly',
  [CounterResetPeriod.YEARLY]: 'Yearly',
};
